
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';import { apiService } from '../../constants/ApiService';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';

const AllLevels = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const authData = useSelector(state => state.authState);
    const [userDetail, setUserDetail] = useState(authData.user);
    const [levelList, setLevelList] = useState([]); 

    const getLevelList = async (stage) => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/Lv_Details_Master/Get_Lv_Stage_Wise?stageId=${stage}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            console.log(response, "level")

            if (response.status === true) {
                setLevelList(response.data);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    useEffect(() => {

        if (authData.login) {
            getLevelList(location.state.stage)
        }
    }, [])

    const handleLevelClick = (level) => {        
        navigate("/all-rewards",{state:{level:level}}) 
    };
    return(
        <>
            <section className="user-dashboard-section section-b-space">
                    <div className="container-fluid-lg">
                        <div className="row">
                            <div className="col-xxl-12 col-lg-12">  
                            <div className='dashboard-card'>
                            <div className="title">
                                            <h2>All Levels</h2>
                                            <span className="title-leaf">
                                                <svg className="icon-width bg-gray">
                                                    <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                </svg>
                                            </span>
                                        </div>
                                        {levelList.map((item) => {
                                            return (
                                                <>
                                                    <div onClick={() => { item.lv_status === "open" && handleLevelClick(item.id) }} className={`seller-grid-box seller-grid-box-1 shadow-lg mb-2 ${item.lv_status === "open" ? "" : "bg-secondary"}`}>
                                                        <div className="grid-image mb-0">
                                                            <div className="contain-name">
                                                                <div>

                                                                    <h3 className="mr-3">{item.lv_name} 
                                                                    {/* <label className="product-label float-end"> 4 Reward Cards Present</label> */}
                                                                    </h3>
                                                                    <div className="since-number">
                                                                        <h5>{item.lv_short_desc}</h5>
                                                                    </div>
                                                                    <div className="since-number">
                                                                        <h6>{item.lv_desc}</h6>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="image float-end">
                                                                <img
                                                                    src={item.lv_status === "open" ? "../assets/images/level/trophy-icon-color.png" : "../assets/images/level/trophy-icon-grayscale.png"}
                                                                    className="img-fluid"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <i className="fa-solid fa-angle-right nav-link text-success"></i>

                                                        </div>
                                                    </div>
                                                </>)
                                        })}
                            </div>
                            </div> 
                        </div>
                    </div>
            </section>
        </>)
}

export default AllLevels;